import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React from "react";
import { Document } from "../objects/Document.interface";

export type DocumentItemListProps = {
    doc: Document
}

export default function DocumentItemList(props:DocumentItemListProps){

    const {id, title, sort} = props.doc;
    const { attributes, listeners, setNodeRef, transform, transition} = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    }
    return (
     
        <div 
            ref = {setNodeRef}
            {...attributes}
            {...listeners}
            style = {style}
            className={(props.doc.isSelected === false)?'area-document-item':'area-document-item area-document-item-selected'} >
            {props.doc.title}
        </div>
              
     
    )
}